// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"dropdown_dropdown__3YtoI"};